<template>
    <section id="partner_content">

        <div class="container">

            <div class="row" id="first_row">

                <!-- In Small Screen -->
                <h3 class="mt-4 mb-0 d-block d-lg-none">الشركات التابعة</h3>

                <div class="col-12 col-lg-6 mt-3 mt-lg-4 order-2 order-lg-1">

                    <div class="col_one_content d-flex flex-column justify-content-start w-100 h-100">

                        <h3 class="d-none d-lg-block">الشركات التابعة</h3>

                        <p>نعمل في ذكاء القابضة على توفير الكثير من الشركات والمشاريع التابعة لنا حتى نواكب عصر التكنولوجيا.
                        </p>

                        <div id="sponsor_wrapper" class="mt-3 myLine">

                            <div class="row row-cols-4 row-cols-lg-5 g-4 d-flex justify-content-center">

                                <div class="col">
                                    <div class="sponsor_logo_wrapper">
                                        <img src="@/assets/images/partners/logo_sponsor_1.webp" alt="">
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="sponsor_logo_wrapper">
                                        <img src="@/assets/images/partners/logo_sponsor_2.webp" alt="">
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="sponsor_logo_wrapper">
                                        <img src="@/assets/images/partners/logo_sponsor_3.webp" alt="">
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="sponsor_logo_wrapper">
                                        <img src="@/assets/images/partners/logo_sponsor_4.webp" alt="">
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="sponsor_logo_wrapper">
                                        <img src="@/assets/images/partners/logo_sponsor_5.webp" alt="">
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="sponsor_logo_wrapper">
                                        <img src="@/assets/images/partners/logo_sponsor_6.webp" alt="">
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="sponsor_logo_wrapper">
                                        <img src="@/assets/images/partners/logo_sponsor_7.webp" alt="">
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="sponsor_logo_wrapper">
                                        <img src="@/assets/images/partners/logo_sponsor_8.webp" alt="">
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="sponsor_logo_wrapper">
                                        <img src="@/assets/images/partners/logo_sponsor_9.webp" alt="">
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="sponsor_logo_wrapper">
                                        <img src="@/assets/images/partners/logo_sponsor_10.webp" alt="">
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="sponsor_logo_wrapper">
                                        <img src="@/assets/images/partners/logo_sponsor_11.webp" alt="">
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="sponsor_logo_wrapper">
                                        <img src="@/assets/images/partners/logo_sponsor_12.webp" alt="">
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="sponsor_logo_wrapper">
                                        <img src="@/assets/images/partners/logo_sponsor_13.webp" alt="">
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="sponsor_logo_wrapper">
                                        <img src="@/assets/images/partners/logo_sponsor_14.webp" alt="">
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="sponsor_logo_wrapper">
                                        <img src="@/assets/images/partners/logo_sponsor_15.webp" alt="">
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="sponsor_logo_wrapper">
                                        <img src="@/assets/images/partners/logo_sponsor_16.webp" alt="">
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="sponsor_logo_wrapper">
                                        <img src="@/assets/images/partners/logo_sponsor_17.webp" alt="">
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="sponsor_logo_wrapper">
                                        <img src="@/assets/images/partners/logo_sponsor_18.webp" alt="">
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>

                <div
                    class="col-12 col-lg-6 mt-3 mt-lg-4 d-flex justify-content-center align-items-start order-1 order-lg-2">

                    <div class="col_two_content">
                        <div class="img_wrapper">
                            <img src="@/assets/images/partners/partner_img.webp" alt="">
                        </div>
                    </div>

                </div>

            </div>

            <div class="mb-3 mb-lg-0" id="second_row">

                <h3 class="mt-3 mt-sm-0">شركاء النجاح</h3>

                <p>نعتز ونفخر في ذكاء القابضة بشركاء النجاح ونسعى أن نكون دائما في المقدمة داخل وخارج المملكة.</p>

                <div id="partner_wrapper" class="m-3 p-3">

                    <div class="row row-cols-3 row-cols-lg-5 g-4 d-flex justify-content-center">

                        <div class="col">
                            <div class="partner_logo_wrapper">
                                <img src="@/assets/images/partners/logo_partner_1.webp" alt="">
                            </div>
                        </div>

                        <div class="col">
                            <div class="partner_logo_wrapper">
                                <img src="@/assets/images/partners/logo_partner_2.webp" alt="">
                            </div>
                        </div>

                        <div class="col">
                            <div class="partner_logo_wrapper">
                                <img src="@/assets/images/partners/logo_partner_3.webp" alt="">
                            </div>
                        </div>

                        <div class="col">
                            <div class="partner_logo_wrapper">
                                <img src="@/assets/images/partners/logo_partner_4.webp" alt="">
                            </div>
                        </div>

                        <div class="col">
                            <div class="partner_logo_wrapper">
                                <img src="@/assets/images/partners/logo_partner_5.webp" alt="">
                            </div>
                        </div>

                        <div class="col">
                            <div class="partner_logo_wrapper">
                                <img src="@/assets/images/partners/logo_partner_6.webp" alt="">
                            </div>
                        </div>

                        <div class="col">
                            <div class="partner_logo_wrapper">
                                <img src="@/assets/images/partners/logo_partner_7.webp" alt="">
                            </div>
                        </div>

                        <div class="col">
                            <div class="partner_logo_wrapper">
                                <img src="@/assets/images/partners/logo_partner_8.webp" alt="">
                            </div>
                        </div>

                        <div class="col">
                            <div class="partner_logo_wrapper">
                                <img src="@/assets/images/partners/logo_partner_9.webp" alt="">
                            </div>
                        </div>

                        <div class="col">
                            <div class="partner_logo_wrapper">
                                <img src="@/assets/images/partners/logo_partner_10.webp" alt="">
                            </div>
                        </div>

                        <div class="col">
                            <div class="partner_logo_wrapper">
                                <img src="@/assets/images/partners/logo_partner_11.webp" alt="">
                            </div>
                        </div>

                        <div class="col">
                            <div class="partner_logo_wrapper">
                                <img src="@/assets/images/partners/logo_partner_12.webp" alt="">
                            </div>
                        </div>

                        <div class="col">
                            <div class="partner_logo_wrapper">
                                <img src="@/assets/images/partners/logo_partner_13.webp" alt="">
                            </div>
                        </div>

                    </div>

                </div>

            </div>

        </div>

    </section>
</template>

<script>
export default {
    name: 'Partner',
}
</script>

<style lang="scss" scoped>
#partner_content {

    min-height: 100vh;

    margin-top: 72px;

    @include breakpoints(x-small) {
        margin-top: 86px;
    }

    @include breakpoints(small) {
        margin-top: 86px;
    }

    @include breakpoints(medium) {
        margin-top: 86px;
    }

    .container {

        #first_row {

            h3 {
                font-family: 'FFShamelFamily-Bold';
                color: $Green;
                font-size: 18px;
                line-height: 180%;
            }

            .col_one_content {

                p {
                    color: $White;
                    font-size: 16px;
                    line-height: 180%;
                    text-align: justify;
                    margin-bottom: 0;
                }

                #sponsor_wrapper {

                    .row {

                        .col {

                            .sponsor_logo_wrapper {

                                height: 40px;

                                img {

                                    width: 100%;
                                    height: 100%;
                                    object-fit: contain;

                                }

                            }

                        }

                    }

                }

                // https://stackoverflow.com/questions/23584120/line-before-and-after-title-over-image

                .myLine:before,
                .myLine:after {
                    content: "";
                    display: inline-block;
                    width: 116px;
                    vertical-align: middle;
                    border-bottom: 2px solid $Green;

                    /* @include breakpoints(x-small) {
                        width: 70px;
                    } */

                    @include breakpoints(small) {
                        width: 90px;
                    }

                    @include breakpoints(medium) {
                        width: 116px;
                    }

                    @include breakpoints(large) {
                        width: 70px;
                    }

                    @include breakpoints(x-Large) {
                        width: 90px;
                    }
                }

                .myLine:before {
                    margin: 0 80% -72% -55%;

                    @include breakpoints(x-small) {
                        display: none;
                    }

                    @include breakpoints(small) {
                        margin: 0 75% -115% -55%;
                    }

                    @include breakpoints(medium) {
                        margin: 0 72% -85% -55%;
                    }

                    @include breakpoints(large) {
                        margin: 0 81% -100% -55%;
                    }

                    @include breakpoints(x-Large) {
                        margin: 0 81% -85% -55%;
                    }
                }

                .myLine:after {
                    margin: -8% 2% 0 0;

                    @include breakpoints(x-small) {
                        display: none;
                    }

                    @include breakpoints(small) {
                        margin: -9% 6% 0 0;
                    }

                    @include breakpoints(medium) {
                        margin: -7% 9% 0 0;
                    }

                    @include breakpoints(large) {
                        margin: -12% 3% 0 0;
                    }

                    @include breakpoints(x-Large) {
                        margin: -8% 3% 0 0;
                    }
                }

            }

            // https://stackoverflow.com/questions/31854185/how-to-add-border-in-my-clip-path-polygon-css-style
            .col_two_content {

                position: relative;

                width: 636px;
                height: 426px;

                @include breakpoints(x-small) {
                    width: 351px;
                    height: 235px;
                }

                @include breakpoints(small) {
                    width: 516px;
                    height: 345px;
                }

                @include breakpoints(medium) {
                    width: 696px;
                    height: 466px;
                }

                @include breakpoints(large) {
                    width: 456px;
                    height: 305px;
                }

                @include breakpoints(x-Large) {
                    width: 546px;
                    height: 366px;
                }

                background: $Green;
                box-sizing: border-box;

                // https://www.cssportal.com/css-clip-path-generator/
                // CSS Vendor Prefixes
                -webkit-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -moz-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -o-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -ms-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);

                .img_wrapper {

                    position: absolute;
                    top: 1px;
                    left: 1px;

                    width: 634px;
                    height: 424px;

                    @include breakpoints(x-small) {
                        width: 349px;
                        height: 233px;
                    }

                    @include breakpoints(small) {
                        width: 514px;
                        height: 343px;
                    }

                    @include breakpoints(medium) {
                        width: 694px;
                        height: 464px;
                    }

                    @include breakpoints(large) {
                        width: 454px;
                        height: 303px;
                    }

                    @include breakpoints(x-Large) {
                        width: 544px;
                        height: 364px;
                    }

                    // https://www.cssportal.com/css-clip-path-generator/
                    // CSS Vendor Prefixes
                    -webkit-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    -moz-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    -o-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    -ms-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);

                    // border: solid 2px $Green;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        opacity: 0.9;
                    }

                    img:hover {
                        opacity: 1;
                        -webkit-transition: opacity 0.5s linear 0.2s;
                        -moz-transition: opacity 0.5s linear 0.2s;
                        transition: opacity 0.5s linear 0.2s;
                    }

                }

            }

        }

        #second_row {

            h3 {

                font-family: 'FFShamelFamily-Bold';
                font-size: 18px;
                line-height: 180%;
                color: $Green;
            }

            p {
                color: $White;
                font-size: 16px;
                line-height: 180%;
                text-align: justify;
                margin-bottom: 0;
            }

            #partner_wrapper {

                border-radius: 8px;
                border: 1px solid $White;

                .row {

                    .col {

                        .partner_logo_wrapper {

                            height: 56px;

                            img {

                                width: 100%;
                                height: 100%;
                                object-fit: contain;

                            }

                        }

                    }

                }

            }

        }

    }

}
</style>